import { render, staticRenderFns } from "./evaluateDetails.vue?vue&type=template&id=2a1420b6&scoped=true"
import script from "./evaluateDetails.vue?vue&type=script&lang=js"
export * from "./evaluateDetails.vue?vue&type=script&lang=js"
import style0 from "./evaluateDetails.vue?vue&type=style&index=0&id=2a1420b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1420b6",
  null
  
)

export default component.exports